/** 
 Copyright Highway9 Networks Inc. 
 */ 
import { Network } from "~/types/network";
import APIService from "./APIServices";
import { MonitoringSystem } from "~/types/monitoringSystem";
import { AaaServerProfile } from "~/types/AAAProfile";

const networkAPI = new APIService<Network>('networks');
const monitoringSystemAPI = new APIService<MonitoringSystem>('networks/monitoringSystems');
const aaaServerProfileAPI = new APIService<AaaServerProfile>('networks/aaaServerProfile');

export const networkService = {
  getNetworks: networkAPI.getAll,
  updateNetwork : networkAPI.update,
  getSNMPData: monitoringSystemAPI.getAll,
  addSNMPData: monitoringSystemAPI.create,
  updateSNMPData: monitoringSystemAPI.update,
  deleteSNMP: monitoringSystemAPI.delete,
  getAAAServerProfilesData: aaaServerProfileAPI.getAll,
  createAAAServerProfile: aaaServerProfileAPI.create,
  updateAAAServerProfile: aaaServerProfileAPI.update,
  deleteAAAServerProfile: aaaServerProfileAPI.delete,
};